import { useEffect, useState } from "react";
import FormField from "./FormField";
import Text from "./Text";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import { ProgressSpinner } from "primereact/progressspinner";
import useAuthHttp from "../hooks/useAuthHttp";
import { useQuery } from "@tanstack/react-query";

export interface IFund {
    ticker_symbol: string;
    company_short_name: string;
    fund_type: "B3" | "CVM";
}

interface IFundList {
    if_list: IFund[];
}

export interface IFundSearchSelectorProps {
    selected: IFund|undefined;
    select: (currency: IFund|undefined) => void;
    hasError?: boolean;
    error?: string;
}

const FundSearchSelector = (props: IFundSearchSelectorProps) => {
    const [searchQueryDebounce, setSearchQueryDebounce] = useState<string>("");
    const [searchQuery, setSearchQuery] = useState<string>("");

    const authHttp = useAuthHttp();
    const fundQuery = useQuery({
        queryKey: ["stock", searchQueryDebounce],
        queryFn: async () => {
            if (!searchQueryDebounce) {
                return { if_list: [] };
            }
            
            return await authHttp.doGet<IFundList>("/inv_fund?search=" + searchQueryDebounce);
        }
    });
    useEffect(() => {
        const timeout = setTimeout(async () => {
            setSearchQueryDebounce(searchQuery);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQuery]);

    return (
        <FormField
            id="fundSearchSelector"
            label="Fundo / ETF / Prev."
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText 
                    value={props.selected ? `${props.selected.ticker_symbol} - ${props.selected.company_short_name}` : searchQuery}
                    className="w-full pr-5"
                    placeholder="Fundo, ETF ou previdência (BRAX11, HGLG11 ou CNPJ)"
                    invalid={props.hasError}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                    }}
                />
                
                {
                    props.selected && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.select(undefined);
                            setSearchQuery("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                fundQuery.isPending && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!fundQuery.data?.if_list?.length && !props.selected && !fundQuery.isPending && searchQuery && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            fundQuery.data.if_list.map(fund => {
                                return (
                                    <li key={fund.ticker_symbol}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                props.select(fund);
                                                setSearchQuery("");
                                            }}
                                        >
                                            {fund.ticker_symbol} - {fund.company_short_name}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default FundSearchSelector;